import { handleActions } from 'redux-actions'

import { unsubscribeSuccess } from './actions'
import defaultState from './defaultState'

export default handleActions({
  [unsubscribeSuccess]: (state) => ({ ...state, isUnsubscribed: true })
}, defaultState)
